<template>
    <div class="ppv2-flex ppv2-flex-wrap ppv2-mb-8 ppv2-w-full" :style="{ gap: normalizeSize(16, true) }">
        <StatsCard
            v-for="item in navItems"
            :key="item.key"
            class="ppv2-flex-1 ppv2-min-w-[200px]"
            :isActive="activeTab === item.key"
            :count="stats[item.countKey] || 0"
            :label="item.label"
            :icon="item.icon"
            @click="onItemClick(item)"
        />
    </div>
</template>

<script>
import normalizeSize from '../../../utils/normalizeSize'

import StatsCard from './StatsCard.vue'
import ProductIcon from './ProductIcon.vue'
import CategoryIcon from './CategoryIcon.vue'
import PackIcon from './PackIcon.vue'
import OptionIcon from './OptionIcon.vue'
import TableIcon from './TableIcon.vue'
import TagIcon from './TagIcon.vue'
import StockMovementIcon from './StockMovementIcon.vue'

export default {
    name: 'FoodStatsNavigation',
    components: {
        StatsCard,
    },
    props: {
        activeTab: {
            type: String,
            required: true,
        },
        stats: {
            type: Object,
            required: true,
            default: () => ({
                products: 0,
                categories: 0,
                packs: 0,
                options: 0,
                tables: 0,
                tags: 0,
                stock_movements_today: 0,
            }),
        },
    },
    data() {
        return {
            navItems: [
                {
                    key: 'carte',
                    countKey: 'products',
                    label: this.$t('food.navigation.products'),
                    icon: ProductIcon,
                },
                {
                    key: 'categories',
                    countKey: 'categories',
                    label: this.$t('food.navigation.categories'),
                    icon: CategoryIcon,
                },
                {
                    key: 'tags',
                    countKey: 'tags',
                    label: this.$t('food.navigation.tags'),
                    icon: TagIcon,
                },
                {
                    key: 'options',
                    countKey: 'options',
                    label: this.$t('food.navigation.options_supplements'),
                    icon: OptionIcon,
                },
                {
                    key: 'stock_movements',
                    countKey: 'stock_movements_today',
                    label: this.$t('food.navigation.stock_movements'),
                    icon: StockMovementIcon,
                    // Page dédiée : navigation Turbo (passe par `turbo:before-visit`, donc par les gardes de sortie)
                    href: '/back-office/v3/food/stock-movements',
                },
            ],
        }
    },
    methods: {
        normalizeSize,
        onItemClick(item) {
            if (item.href) {
                if (this.activeTab === item.key) return
                if (window.Turbo) {
                    window.Turbo.visit(item.href)
                } else {
                    window.location.href = item.href
                }
                return
            }
            this.$emit('click', item.key)
        },
    },
}
</script>
